<!--
    see comment in _nav-layout.cshtml. Do not make any changes to the templates of
        pc-nav-layout.vue
        navHeader.vue
        navSidebar.vue
    without also making sure the corresponding changes are made to the necessary cshtml views.
-->
<template>
    <div
        v-if="!hideNavigation"
        class="vh-100 vw-100 overflow-hidden position-relative print-expand-wh">
        <nav-header
            v-bind:hide-menu-items="hideMenuItems"
            class="d-print-none" />
        <div class="pc-viewport-height d-flex print-expand-wh">
            <nav-sidebar
                v-if="showSidebarMenu"
                ref="navSidebar"
                v-bind:show-expander="!hideMenuItems"
                class="d-print-none" />
            <main class="d-flex flex-column flex-grow-1 overflow-hidden bg-white print-expand-wh">
                <!-- this id is referenced by some scrolling utilities, search before changing -->
                <div
                    id="NavLayoutPageContent"
                    class="flex-grow-1 overflow-auto">
                    <nav-banners />
                    <slot />
                </div>
                <nav-buttons>
                    <slot name="nav-buttons" />
                </nav-buttons>
            </main>
        </div>
    </div>
    <div
        v-else
        class="w-100 position-relative">
        <div class="d-flex">
            <main class="d-flex flex-column flex-grow-1 overflow-hidden bg-white print-expand-wh">
                <div class="flex-grow-1 overflow-auto">
                    <slot />
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { BP } from "Responsive/breakpoint";
    import { isAtLeast } from "Responsive/manager";
    import navSidebar from "./Navigation/navSidebar.vue";
    import navHeader from "./Navigation/navHeader.vue";
    import navBanners from "./Navigation/navBanners.vue";
    import navButtons from "./Navigation/navButtons.vue";

    export default {
        components: {
            navSidebar,
            navHeader,
            navBanners,
            navButtons
        },
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            hideNavigation: { type: Boolean, required: false, default: false },
            hideMenuItems: { type: Boolean, required: false, default: false }
        },
        data() {
            return {
                shownFloatMenuType: null
            };
        },
        computed: {
            showSidebarMenu() {
                return isAtLeast(this.viewport, BP.sm);
            }
        }
    };
</script>

<style lang="scss">
    @import "./Navigation/_nav-style-vars.scss";

    .pc-viewport-height {
        height: calc(100vh - $pc-nav-header-height);
    }
</style>
